import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import FilterGroupChips from './FilterGroupChips';
import { translate } from '../../Services/translation';
import { useDispatch } from 'react-redux';
import { clearAllFilters } from '../../Actions/ProductFiltering.action';
import { useMemo } from 'react';
import clsx from 'clsx';

const ActiveFilterChips = () => {
  const dispatch = useDispatch();
  const filters = useTypedSelector(
    (state) => state.productFiltering.filters
  );
  const hasAnyOptionSelected = useMemo(
    () => filters?.some((f) => f.selectedOptions.length > 0),
    [filters]
  );

  return hasAnyOptionSelected ? (
    <div
      className={clsx(
        'gap-2',
        'mb-4',
        '-mt-2',
        'flex',
        'items-center',
        'text-sm',
        'md-down:hidden'
      )}
    >
      {filters.map((g) => (
        <FilterGroupChips key={g.id + 'chips'} filterGroup={g} />
      ))}
      <a
        className={clsx('text-sm', 'underline', 'cursor-pointer')}
        onClick={() => dispatch(clearAllFilters())}
      >
        {translate('product-filtering.clear-all-filters')}
      </a>
    </div>
  ) : null;
};

export default ActiveFilterChips;
